import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    cta: 'Let’s go!',
    description:
      'You just need to provide some information from the draft statutes of your client’s company.',
    title: 'Let’s start with your client’s company file',
  },
  fr: {
    cta: 'C’est parti\u00A0!',
    description:
      'Il vous suffit de saisir quelques informations clés à partir du projet de statuts de l’entreprise de votre client·e.',
    title: 'Commençons par le dossier de l’entreprise de votre client•e',
  },
} as const);

export default locales;
